import {
  Button,
  Center,
  FormControl,
  HStack,
  Input,
  Radio,
  Select,
  Text,
  View,
  VStack,
  Box,
} from "native-base";
import React, { useMemo, useState, useEffect, useCallback } from "react";
import TimeInput from "react-time-picker-input";
import Notiflix from "notiflix";

import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import PlacesAutocomplete from "../components/PlacesAutocomplete";
import { addressForLocation } from "../utils/placeAddress";
import { compose } from "redux";
import { connect } from "react-redux";
import { Redirect, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { editBiz } from "../Redux/actions";
import MultiImageInput from "../components/multi-image-input";
import { useParams } from "react-router-dom";

import { Multiselect } from "multiselect-react-dropdown";

import { isLoaded as isFirestoreLoaded, useFirestoreConnect } from "react-redux-firebase";
import { useSelector } from "react-redux";

import AccessibilityForm from "./AccesibilityForm";
import firebase from "firebase/app";
import "firebase/auth";
import { ENDPOINTS } from "../config";
import POSRequestForm from "../components/integration/POSRequestForm";
import useStaffRole from "../hooks/useStaffRole";
const EditBusiness = ({ auth }) => {
  useEffect(() => { document.title = "Edit Business | Piatto"; }, []);
  const { id } = useParams();
  const { isOwner } = useStaffRole(id);
  const history = useHistory();
  const dispatch = useDispatch();
  // getting cuisines
  useFirestoreConnect([
    {
      collection: "Cuisines",
    },
  ]);

  const Cuisine = useSelector(({ firestore: { ordered } }) => ordered.Cuisines);
  // getting busoiness types
  useFirestoreConnect([
    {
      collection: "Type",
    },
  ]);
  const BizTypes = useSelector(({ firestore: { ordered } }) => ordered.Type);

  // Load the venue directly by Firestore doc ID. Previously this page relied on
  // a Business listener left over from whichever page linked here, so opening
  // /editBusiness/:id directly (bookmark, Stripe return URL, claim success)
  // showed a blank form whose Save could overwrite the venue.
  const venueStoreKey = `editBusiness_${id}`;
  useFirestoreConnect(
    id ? [{ collection: "Business", doc: id, storeAs: venueStoreKey }] : []
  );
  const venueDoc = useSelector(
    ({ firestore: { data } }) => (data ? data[venueStoreKey] : undefined)
  );
  const venueLoaded = isFirestoreLoaded(venueDoc);
  const venueNotFound = venueLoaded && !venueDoc;

  const business = useMemo(
    () => (venueDoc ? { ...venueDoc, id } : null),
    [venueDoc, id]
  );
  // True once the form has been populated from the loaded venue. Save stays
  // blocked until then so a blank/default form can never be written.
  const [prefilledId, setPrefilledId] = useState(null);
  const formReady = !!business && prefilledId === id;

  // need to add
  const [form, setForm] = useState({});
  const [bizAddress, setbizAddress] = useState({ address: "" });
  const [bizLunchOpen, setBizLunchOpen] = useState("12:00"); //
  const [bizLunchClose, setBizLunchClose] = useState("15:00");
  const [bizDinnerOpen, setBizDinnerOpen] = useState("06:00");
  const [bizDinnerClose, setBizDinnerClose] = useState("21:30");

  const [bizName, setBizName] = useState(""); //
  const [bizType, setBType] = useState(""); /// bussinees types \

  //Nuber of seats
  const [bizInsideLowSeatNo, setBizInsideLowSeatNo] = useState("");
  const [bizInsideHighSeatNo, setBizInsideHighSeatNo] = useState("");
  const [bizOutsideLowSeatNo, setBizOutsideLowSeatNo] = useState("");
  const [bizOutsideHighSeatNo, setBizOutsideHighSeatNo] = useState("");
  // Number of tables
  const [bizInsideLowTableNo, setBizInsideLowTableNo] = useState("");
  const [bizInsideHighTableNo, setBizInsideHighTableNo] = useState("");
  const [bizOutsideLowTableNo, setBizOutsideLowTableNo] = useState("");
  const [bizOutsideHighTableNo, setBizOutsideHighTableNo] = useState("");
  //Open and Close
  const [bizMondayOpen, setBizMondayOpen] = useState("08:00"); //
  const [bizMondayClose, setBizMondayClose] = useState("21:30");
  const [bizTuesdayOpen, setBizTuesdayOpen] = useState("08:00");
  const [bizTuesdayClose, setBizTuesdayClose] = useState("21:30");
  const [bizWednesdayOpen, setBizWednesdayOpen] = useState("08:00");
  const [bizWednesdayClose, setbizWednesdayClose] = useState("21:30");
  const [bizThursdayOpen, setBizThursdayOpen] = useState("08:00");
  const [bizThursdayClose, setBizThursdayClose] = useState("21:30");
  const [bizFridayOpen, setBizFridayOpen] = useState("08:00");
  const [bizFridayClose, setbizFridayClose] = useState("21:30");
  const [bizSaturdayOpen, setbizSaturdayOpen] = useState("08:00");
  const [bizSaturdayClose, setBizSaturdayClose] = useState("21:30");
  const [bizSundayOpen, setBizSundayOpen] = useState("08:00");
  const [bizSundayClose, setBizSundayClose] = useState("21:30");
  const [BreakfastS, setBreakfastS] = useState("08:00");
  const [BreakfastF, setBreakfastF] = useState("10:00");

  const [wizard, Setwizard] = useState(0);

  const [bizPhone, setBizPhone] = useState("");
  const [bizEmail, setBizEmail] = useState("");
  const [bizWeb, setBizWeb] = useState("");

  const [bizOrderPhone, setBizOrderPhone] = useState("");
  const [bizOrderEmail, setBizOrderEmail] = useState("");

  const center = useMemo(() => ({ lat: 43.45, lng: -80.49 }), []);
  const [selected, setSelected] = useState(null);
  const [images, setImages] = React.useState({});

  const [bizCuisines, setBizCusines] = React.useState([]);
  const [bizOrderEmailError, setBizOrdermailError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [bizAccessRating, setBizAccessRating] = useState(0);

  // Stripe payment status
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [paymentError, setPaymentError] = useState("");

  const getAuthToken = useCallback(async () => {
    const user = firebase.auth().currentUser;
    if (!user) return null;
    return user.getIdToken();
  }, []);

  // Fetch payment status when business loads
  useEffect(() => {
    if (!business || !id) return;
    let cancelled = false;
    const fetchStatus = async () => {
      try {
        const token = await getAuthToken();
        if (!token || cancelled) return;
        const res = await fetch(ENDPOINTS.paymentStatus(id), {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!cancelled && res.ok) {
          const data = await res.json();
          setPaymentStatus(data);
        }
      } catch {
        // Silently fail — status section will show fallback
      }
    };
    fetchStatus();
    return () => { cancelled = true; };
  }, [business, id, getAuthToken]);

  const handleEnablePayments = async () => {
    setPaymentLoading(true);
    setPaymentError("");
    try {
      const token = await getAuthToken();
      if (!token) throw new Error("Not authenticated");
      const returnUrl = `${window.location.origin}/editBusiness/${id}`;
      const res = await fetch(ENDPOINTS.enablePayments, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          venueId: id,
          returnUrl,
          refreshUrl: returnUrl,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to enable payments");
      // Redirect to Stripe onboarding
      window.location.href = data.accountLink;
    } catch (err) {
      setPaymentError(err.message);
      setPaymentLoading(false);
    }
  };

  const handleResumeOnboarding = async () => {
    setPaymentLoading(true);
    setPaymentError("");
    try {
      const token = await getAuthToken();
      if (!token) throw new Error("Not authenticated");
      const returnUrl = `${window.location.origin}/editBusiness/${id}`;
      const res = await fetch(ENDPOINTS.resumeOnboarding, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          venueId: id,
          returnUrl,
          refreshUrl: returnUrl,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to resume onboarding");
      window.location.href = data.accountLink;
    } catch (err) {
      setPaymentError(err.message);
      setPaymentLoading(false);
    }
  };

  const handleStripeDashboard = async () => {
    setPaymentLoading(true);
    setPaymentError("");
    try {
      const token = await getAuthToken();
      if (!token) throw new Error("Not authenticated");
      const res = await fetch(ENDPOINTS.stripeDashboard, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ venueId: id }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to open dashboard");
      window.open(data.dashboardUrl, "_blank");
    } catch (err) {
      setPaymentError(err.message);
    } finally {
      setPaymentLoading(false);
    }
  };

  // Service options (radio: yes/no/unknown)
  const [bizDineIn, setBizDineIn] = useState(null);
  const [bizDelivery, setBizDelivery] = useState(null);
  const [bizTakeout, setBizTakeout] = useState(null);
  const [bizCurbsidePickup, setBizCurbsidePickup] = useState(null);

  // Meals & drinks (radio: yes/no/unknown)
  const [bizServesBreakfast, setBizServesBreakfast] = useState(null);
  const [bizServesLunch, setBizServesLunch] = useState(null);
  const [bizServesDinner, setBizServesDinner] = useState(null);
  const [bizServesBrunch, setBizServesBrunch] = useState(null);
  const [bizServesBeer, setBizServesBeer] = useState(null);
  const [bizServesWine, setBizServesWine] = useState(null);
  const [bizServesCocktails, setBizServesCocktails] = useState(null);
  const [bizServesCoffee, setBizServesCoffee] = useState(null);
  const [bizServesVegetarianFood, setBizServesVegetarianFood] = useState(null);
  const [bizServesDessert, setBizServesDessert] = useState(null);

  // Amenities (radio: yes/no/unknown)
  const [bizOutdoorSeating, setBizOutdoorSeating] = useState(null);
  const [bizLiveMusic, setBizLiveMusic] = useState(null);
  const [bizMenuForChildren, setBizMenuForChildren] = useState(null);
  const [bizGoodForChildren, setBizGoodForChildren] = useState(null);
  const [bizGoodForGroups, setBizGoodForGroups] = useState(null);
  const [bizGoodForWatchingSports, setBizGoodForWatchingSports] = useState(null);
  const [bizAllowsDogs, setBizAllowsDogs] = useState(null);
  const [bizRestroom, setBizRestroom] = useState(null);

  const handleBizOrderEmailChange = (text) => {
    setBizOrderEmail(text);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (text.length === 0 || emailRegex.test(text)) {
      setBizOrdermailError("");
    } else {
      setBizOrdermailError("Invalid email address");
    }
  };

  const handleEmailChange = (text) => {
    setBizEmail(text);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (text.length === 0 || emailRegex.test(text)) {
      setEmailError("");
    } else {
      setEmailError("Invalid email address");
    }
  };

  const handleFormChange = (updatedForm) => {
    setForm(updatedForm); // keep latest form state
  };

  // locationData: { lat, lng }. From an address pick, address + components
  // come with it (Places details); from a map click they don't, so we
  // reverse-geocode, and if that fails keep the pin and the previous address.
  const handleLatLang = async (locationData, address, components) => {
    setSelected(locationData);
    const add = await addressForLocation(locationData, address, components);
    if (add) {
      setbizAddress(add);
    } else {
      Notiflix.Report.Warning(
        "Address not updated",
        "We moved the pin but couldn't look up the street address for that spot. Search for the address instead if it's wrong.",
        "Close"
      );
    }
  };

  const crop = {
    unit: "%",
    aspect: 4 / 3,
    width: "100",
  };
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ["places"],
  });

  useEffect(() => {
    const fetchData = async () => {
      // Prefill once per venue: later snapshot updates (e.g. Stripe status
      // writes) must not clobber edits the user has already made.
      if (business && Object.keys(business)?.length > 0 && prefilledId !== id) {
        const b = business;

        // Seed coordinates so Save doesn't depend on re-picking the address.
        if (b.bizLat != null && b.bizLon != null) {
          setSelected({ lat: b.bizLat, lng: b.bizLon });
        }

        setBizName(b.bizName || "");
        setBType(b.bizType || "");
        setForm({ ...b });
        setbizAddress({ address: b.bizAddress || "" });

        setBizLunchOpen(b.bizLunchOpen || "12:00");
        setBizLunchClose(b.bizLunchClose || "15:00");
        setBizDinnerOpen(b.dinnerOpen || "06:00");
        setBizDinnerClose(b.bizDinnerOpen || "21:30");

        setBizInsideLowSeatNo(b.bizInsideLowSeatNo || "");
        setBizInsideHighSeatNo(b.bizInsideHighSeatNo || "");
        setBizOutsideLowSeatNo(b.bizOutsideLowSeatNo || "");
        setBizOutsideHighSeatNo(b.bizOutsideHighSeatNo || "");

        setBizInsideLowTableNo(b.bizInsideLowTableNo || "");
        setBizInsideHighTableNo(b.bizInsideHighTableNo || "");
        setBizOutsideLowTableNo(b.bizOutsideLowTableNo || "");
        setBizOutsideHighTableNo(b.bizOutsideHighTableNo || "");

        setBizMondayOpen(b.bizMondayOpen || "08:00");
        setBizMondayClose(b.bizMondayClose || "21:30");
        setBizTuesdayOpen(b.bizTuesdayOpen || "08:00");
        setBizTuesdayClose(b.bizTuesdayClose || "21:30");
        setBizWednesdayOpen(b.bizWednesdayOpen || "08:00");
        setbizWednesdayClose(b.bizWednesdayClose || "21:30");
        setBizThursdayOpen(b.bizThursdayOpen || "08:00");
        setBizThursdayClose(b.bizThursdayClose || "21:30");
        setBizFridayOpen(b.bizFridayOpen || "08:00");
        setbizFridayClose(b.bizFridayClose || "21:30");
        setbizSaturdayOpen(b.bizSaturdayOpen || "08:00");
        setBizSaturdayClose(b.bizSaturdayClose || "21:30");
        setBizSundayOpen(b.bizSundayOpen || "08:00");
        setBizSundayClose(b.bizSundayClose || "21:30");

        setBreakfastS(b.BreakfastS || "08:00");
        setBreakfastF(b.BreakfastF || "10:00");

        setBizPhone(b.bizPhone || "");
        setBizEmail(b.bizEmail || "");
        setBizWeb(b.bizWeb || "");
        setBizOrderPhone(b.bizOrderPhone || "");
        setBizOrderEmail(b.bizOrderEmail || "");

        setImages(b.images || {});

        setBizCusines(b.bizCuisines || []);

        // Service options
        setBizDineIn(b.bizDineIn ?? null);
        setBizDelivery(b.bizDelivery ?? null);
        setBizTakeout(b.bizTakeout ?? null);
        setBizCurbsidePickup(b.bizCurbsidePickup ?? null);

        // Meals & drinks
        setBizServesBreakfast(b.bizServesBreakfast ?? null);
        setBizServesLunch(b.bizServesLunch ?? null);
        setBizServesDinner(b.bizServesDinner ?? null);
        setBizServesBrunch(b.bizServesBrunch ?? null);
        setBizServesBeer(b.bizServesBeer ?? null);
        setBizServesWine(b.bizServesWine ?? null);
        setBizServesCocktails(b.bizServesCocktails ?? null);
        setBizServesCoffee(b.bizServesCoffee ?? null);
        setBizServesVegetarianFood(b.bizServesVegetarianFood ?? null);
        setBizServesDessert(b.bizServesDessert ?? null);

        // Amenities
        setBizOutdoorSeating(b.bizOutdoorSeating ?? null);
        setBizLiveMusic(b.bizLiveMusic ?? null);
        setBizMenuForChildren(b.bizMenuForChildren ?? null);
        setBizGoodForChildren(b.bizGoodForChildren ?? null);
        setBizGoodForGroups(b.bizGoodForGroups ?? null);
        setBizGoodForWatchingSports(b.bizGoodForWatchingSports ?? null);
        setBizAllowsDogs(b.bizAllowsDogs ?? null);
        setBizRestroom(b.bizRestroom ?? null);

        // await handleLatLang({ lat: b.bizLat, long: b.bizLon }, b.bizAddress);
        setPrefilledId(id);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [business, id]);

  const handleScoreChange = (score) => {
    setBizAccessRating(score);
  };

  if (!auth.uid) return <Redirect to="/" />;

  return (
    <VStack
      role="main"
      flex="1"
      px="6"
      py="9"
      _light={{ bg: "white" }}
      _dark={{ bg: "coolGray.800" }}
      space="3"
      justifyContent="space-between"
    >
      <Center>
        <VStack textAlign={"center"} w={"70%"} space={4}>
          <View>
          {/* ── Get set up on Piatto (Owner only) ── */}
          {isOwner && (
          <VStack space={4} mt={2} mb={8}>
            <Text fontSize="xl" fontWeight="bold" color="coolGray.800">
              Get set up on Piatto
            </Text>
            <Text fontSize="sm" color="coolGray.600">
              Two steps to go live: connect your POS so we can import your menu and send you
              orders, and set up payments so you can get paid. After connecting, we'll have
              most of the details below already — please review them to verify exactly how
              your venue will appear on Piatto (trading hours, accessibility, and more).
            </Text>

            {paymentError ? (
              <Box bg="red.100" p={3} borderRadius="md">
                <Text color="red.700" fontSize="sm">{paymentError}</Text>
              </Box>
            ) : null}

            {/* POS connection — Square self-serve or request for others */}
            <POSRequestForm
              businessId={id}
              business={business}
            />

            {/* Stripe Enable Payments CTA */}
            {(!paymentStatus || paymentStatus.status === "not_started") && (
              <Box bg="coolGray.100" p={5} borderRadius="lg" borderWidth={1} borderColor="coolGray.200">
                <Text fontSize="md" fontWeight="semibold" mb={2}>
                  Set up payments (required)
                </Text>
                <Text fontSize="sm" color="coolGray.600" mb={3}>
                  Piatto orders are paid inside the Piatto app, and the money comes straight to
                  you. Customers enter their card just once, then reorder anywhere on Piatto in
                  a couple of taps — which, for someone with a disability, makes ordering far
                  easier, and is what lets their saved needs travel with them from venue to
                  venue.
                </Text>
                <Text fontSize="sm" fontWeight="semibold" color="coolGray.700" mb={1}>
                  What about my Square?
                </Text>
                <Text fontSize="sm" color="coolGray.600" mb={3}>
                  Your orders still land in Square as normal — each one flagged "Piatto" — so
                  nothing changes for your staff and you can easily see which sales came through
                  us. Only the payment is handled by Piatto instead of your till.
                </Text>
                <Text fontSize="sm" fontWeight="semibold" color="coolGray.700" mb={1}>
                  Where does the money go?
                </Text>
                <Text fontSize="sm" color="coolGray.600" mb={4}>
                  Straight to your bank account. Payments run through our partner Stripe (using
                  Stripe Connect), which collects each payment and passes it through to your
                  account automatically. You set this up once, it takes a few minutes, and your
                  venue shows as a "Piatto Partner" when it's done.
                </Text>
                <Button
                  colorScheme="danger"
                  onPress={handleEnablePayments}
                  isLoading={paymentLoading}
                  isDisabled={paymentLoading}
                >
                  Set Up Stripe Payments
                </Button>
              </Box>
            )}
{/* Onboarding incomplete */}
            {paymentStatus?.status === "onboarding_incomplete" && (
              <Box bg="yellow.100" p={5} borderRadius="lg" borderWidth={1} borderColor="yellow.300">
                <Text fontSize="md" fontWeight="semibold" mb={2}>
                  Complete Payment Setup
                </Text>
                <Text fontSize="sm" color="coolGray.600" mb={4}>
                  You started setting up payments but haven't finished yet.
                  Pick up where you left off to start accepting orders.
                </Text>
                <Button
                  colorScheme="warning"
                  onPress={handleResumeOnboarding}
                  isLoading={paymentLoading}
                  isDisabled={paymentLoading}
                >
                  Complete Setup
                </Button>
              </Box>
            )}
{/* Requirements due */}
            {paymentStatus?.status === "requirements_due" && (
              <Box bg="orange.100" p={5} borderRadius="lg" borderWidth={1} borderColor="orange.300">
                <Text fontSize="md" fontWeight="semibold" color="orange.800" mb={2}>
                  Action Required
                </Text>
                <Text fontSize="sm" color="coolGray.600" mb={2}>
                  Stripe needs additional information to keep your payments active.
                  {paymentStatus.requirementsDeadline
                    ? ` Please complete by ${new Date(paymentStatus.requirementsDeadline * 1000).toLocaleDateString()}.`
                    : " Please update as soon as possible."}
                </Text>
                {paymentStatus.requirementsCurrentlyDue?.length > 0 && (
                  <Text fontSize="xs" color="coolGray.600" mb={3}>
                    Items needed: {paymentStatus.requirementsCurrentlyDue.join(", ")}
                  </Text>
                )}
                <Button
                  colorScheme="warning"
                  onPress={handleResumeOnboarding}
                  isLoading={paymentLoading}
                  isDisabled={paymentLoading}
                >
                  Update Details
                </Button>
              </Box>
            )}          
{/* Pending verification */}
            {paymentStatus?.status === "pending_verification" && (
              <Box bg="blue.100" p={5} borderRadius="lg" borderWidth={1} borderColor="blue.300">
                <Text fontSize="md" fontWeight="semibold" color="blue.800" mb={2}>
                  Verification Pending
                </Text>
                <Text fontSize="sm" color="coolGray.600">
                  Stripe is reviewing your details. This usually takes 1-2 business days.
                  You'll be able to accept payments once verification is complete.
                </Text>
              </Box>
            )}

            {/* Active */}
            {paymentStatus?.status === "active" && (
              <Box bg="green.100" p={5} borderRadius="lg" borderWidth={1} borderColor="green.300">
                <HStack alignItems="center" space={2} mb={2}>
                  <Text fontSize="md" fontWeight="semibold" color="green.800">
                    Payments Active
                  </Text>
                </HStack>
                <Text fontSize="sm" color="coolGray.600" mb={4}>
                  Your venue is accepting payments through Piatto.
                  {paymentStatus.payoutsEnabled
                    ? " Payouts are active."
                    : " Payouts are being set up."}
                </Text>
                <Button
                  variant="outline"
                  colorScheme="coolGray"
                  onPress={handleStripeDashboard}
                  isLoading={paymentLoading}
                  isDisabled={paymentLoading}
                >
                  Open Stripe Dashboard
                </Button>
              </Box>
            )}
          </VStack>
          )}

            <Text fontSize={"2xl"} fontWeight="bold" textAlign="center" mt={4}>
              Edit Business
            </Text>
            <Text mb={10} fontSize={"lg"} textAlign="center">
              After completing the initial POS and Payments setup above, you can review and
              edit the following details to control exactly how your venue appears in the
              Piatto app — including your trading hours, accessibility features, and more.
            </Text>

            <HStack
              justifyContent={"space-between"}
              space={2}
              flexWrap={"wrap"}
            >
              <FormControl w={"48%"}>
                <FormControl.Label>Name of your business</FormControl.Label>
                <Input
                  maxLength={20}
                  onChangeText={(txt) => setBizName(txt)}
                  value={bizName}
                  autoComplete="off"
                  placeholder="Name of your business"
                />
              </FormControl>

              <FormControl w={"48%"}>
                <FormControl.Label>Your business type</FormControl.Label>
                <Select
                  onValueChange={(itemValue) => {
                    let bizTy = BizTypes.find(
                      (typ) => typ["typeName"] === itemValue
                    );
                    setBType({ id: bizTy.id, name: bizTy.typeName });
                  }}
                  selectedValue={bizType?.name || ""}
                  accessibilityLabel="Select your Your business type"
                  placeholder="Select your Your business type"
                >
                  {BizTypes &&
                    BizTypes.map((biz_) => {
                      return (
                        <Select.Item
                          key={biz_.id}
                          label={biz_.typeName}
                          value={biz_.typeName}
                        />
                      );
                    })}
                </Select>
              </FormControl>
            </HStack>
          </View>

          <View>
            <Text fontSize={"2xl"} fontWeight="bold">
              Business Location
            </Text>

            <FormControl>
              <FormControl.Label>Address</FormControl.Label>
              <div className="places-container">
                <PlacesAutocomplete
                  setSelected={handleLatLang}
                  defaultAddress={bizAddress.address}
                />
              </div>
            </FormControl>
            {isLoaded && selected ? (
              <>
                <GoogleMap
                  zoom={18}
                  center={selected ? selected : center}
                  onClick={(e) => {
                    const data = {
                      lat: e.latLng.lat(),
                      lng: e.latLng.lng(),
                    };
                    handleLatLang(data, null);
                  }}
                  mapContainerClassName="map-container"
                >
                  {selected && <Marker position={selected} />}
                </GoogleMap>
              </>
            ) : (
              <></>
            )}
          </View>

          <View>
            <Text fontSize={"2xl"} fontWeight="bold">
              Business Seating
            </Text>

            <HStack justifyContent={"center"} space={2} flexWrap={"wrap"}>
              <FormControl w={"23%"}>
                <FormControl.Label>
                  Total number of seats at inside low tables:
                </FormControl.Label>
                <Input
                  maxLength={2}
                  autoComplete="off"
                  value={bizInsideLowSeatNo}
                  onChangeText={(t) => setBizInsideLowSeatNo(t)}
                  placeholder="inside low tables"
                />
              </FormControl>
              <FormControl w={"23%"}>
                <FormControl.Label>
                  Total number of seats at inside high tables:
                </FormControl.Label>
                <Input
                  maxLength={2}
                  autoComplete="off"
                  value={bizInsideHighSeatNo}
                  onChangeText={(t) => setBizInsideHighSeatNo(t)}
                  placeholder="inside high tables"
                />
              </FormControl>
              <FormControl w={"23%"}>
                <FormControl.Label>
                  Total number of seats at outside low tables:
                </FormControl.Label>
                <Input
                  maxLength={2}
                  autoComplete="off"
                  value={bizOutsideLowSeatNo}
                  onChangeText={(t) => setBizOutsideLowSeatNo(t)}
                  placeholder="outside low tables"
                />
              </FormControl>
              <FormControl w={"23%"}>
                <FormControl.Label>
                  Total number of seats at outside high tables:
                </FormControl.Label>
                <Input
                  maxLength={2}
                  autoComplete="off"
                  value={bizOutsideHighSeatNo}
                  onChangeText={(t) => setBizOutsideHighSeatNo(t)}
                  placeholder="outside high tables"
                />
              </FormControl>
              <FormControl w={"23%"}>
                <FormControl.Label>
                  Total number of inside low tables:
                </FormControl.Label>
                <Input
                  maxLength={2}
                  autoComplete="off"
                  value={bizInsideLowTableNo}
                  onChangeText={(t) => setBizInsideLowTableNo(t)}
                  placeholder="inside low tables"
                />
              </FormControl>
              <FormControl w={"23%"}>
                <FormControl.Label>
                  Total number of inside high tables:
                </FormControl.Label>
                <Input
                  maxLength={2}
                  autoComplete="off"
                  value={bizInsideHighTableNo}
                  onChangeText={(t) => setBizInsideHighTableNo(t)}
                  placeholder="inside high tables"
                />
              </FormControl>
              <FormControl w={"23%"}>
                <FormControl.Label>
                  Total number of outside low tables:
                </FormControl.Label>
                <Input
                  maxLength={2}
                  autoComplete="off"
                  value={bizOutsideLowTableNo}
                  onChangeText={(t) => setBizOutsideLowTableNo(t)}
                  placeholder="outside low tables"
                />
              </FormControl>
              <FormControl w={"23%"}>
                <FormControl.Label>
                  Total number of outside high tables:
                </FormControl.Label>
                <Input
                  maxLength={2}
                  autoComplete="off"
                  value={bizOutsideHighTableNo}
                  onChangeText={(t) => setBizOutsideHighTableNo(t)}
                  placeholder="outside high tables"
                />
              </FormControl>
            </HStack>
          </View>

          <View>
            <Text fontSize={"2xl"} fontWeight="bold">
              Trading Hours
            </Text>
            <Text mb={10} fontSize={"lg"}>
              Please indicate the opening and closing times for each day of the
              week that you are operating. Please also inform us of the
              Breakfast, Lunch and Dinner start/end times. They should be
              recorded in 24 hour time.
            </Text>
            <HStack
              zIndex={10}
              justifyContent={"center"}
              space={10}
              flexWrap={"wrap"}
            >
              <VStack alignItems={"center"}>
                <FormControl.Label>Opening time on Monday:</FormControl.Label>
                <TimeInput
                  value={bizMondayOpen}
                  fullTimeDropdown
                  onChange={(dateString) => setBizMondayOpen(dateString)}
                />
              </VStack>
              <VStack alignItems={"center"}>
                <FormControl.Label>Closing time on Monday:</FormControl.Label>
                <TimeInput
                  value={bizMondayClose}
                  fullTimeDropdown
                  onChange={(dateString) => setBizMondayClose(dateString)}
                />
              </VStack>
            </HStack>
            <HStack
              zIndex={9}
              justifyContent={"center"}
              space={10}
              flexWrap={"wrap"}
            >
              <VStack alignItems={"center"}>
                <FormControl.Label>Opening time on Tuesday:</FormControl.Label>
                <TimeInput
                  value={bizTuesdayOpen}
                  fullTimeDropdown
                  onChange={(dateString) => setBizTuesdayOpen(dateString)}
                />
              </VStack>
              <VStack alignItems={"center"}>
                <FormControl.Label>Closing time on Tuesday:</FormControl.Label>
                <TimeInput
                  value={bizTuesdayClose}
                  fullTimeDropdown
                  onChange={(dateString) => setBizTuesdayClose(dateString)}
                />
              </VStack>
            </HStack>
            <HStack
              zIndex={8}
              justifyContent={"center"}
              space={10}
              flexWrap={"wrap"}
            >
              <VStack alignItems={"center"}>
                <FormControl.Label>
                  Opening time on Wednesday:
                </FormControl.Label>
                <TimeInput
                  value={bizWednesdayOpen}
                  fullTimeDropdown
                  onChange={(dateString) => setBizWednesdayOpen(dateString)}
                />
              </VStack>
              <VStack alignItems={"center"}>
                <FormControl.Label>
                  Closing time on Wednesday:
                </FormControl.Label>
                <TimeInput
                  value={bizWednesdayClose}
                  fullTimeDropdown
                  onChange={(dateString) => setbizWednesdayClose(dateString)}
                />
              </VStack>
            </HStack>
            <HStack
              zIndex={7}
              justifyContent={"center"}
              space={10}
              flexWrap={"wrap"}
            >
              <VStack alignItems={"center"}>
                <FormControl.Label>Opening time on Thursday:</FormControl.Label>
                <TimeInput
                  value={bizThursdayOpen}
                  fullTimeDropdown
                  onChange={(dateString) => setBizThursdayOpen(dateString)}
                />
              </VStack>
              <VStack alignItems={"center"}>
                <FormControl.Label>Closing time on Thursday:</FormControl.Label>
                <TimeInput
                  value={bizThursdayClose}
                  fullTimeDropdown
                  onChange={(dateString) => setBizThursdayClose(dateString)}
                />
              </VStack>
            </HStack>
            <HStack
              zIndex={6}
              justifyContent={"center"}
              space={10}
              flexWrap={"wrap"}
            >
              <VStack alignItems={"center"}>
                <FormControl.Label>Opening time on Friday:</FormControl.Label>
                <TimeInput
                  value={bizFridayOpen}
                  fullTimeDropdown
                  onChange={(dateString) => setBizFridayOpen(dateString)}
                />
              </VStack>
              <VStack alignItems={"center"}>
                <FormControl.Label>Closing time on Friday:</FormControl.Label>
                <TimeInput
                  value={bizFridayClose}
                  fullTimeDropdown
                  onChange={(dateString) => setbizFridayClose(dateString)}
                />
              </VStack>
            </HStack>
            <HStack
              zIndex={5}
              justifyContent={"center"}
              space={10}
              flexWrap={"wrap"}
            >
              <VStack alignItems={"center"}>
                <FormControl.Label>Opening time on Saturday:</FormControl.Label>
                <TimeInput
                  value={bizSaturdayOpen}
                  fullTimeDropdown
                  onChange={(dateString) => setbizSaturdayOpen(dateString)}
                />
              </VStack>
              <VStack alignItems={"center"}>
                <FormControl.Label>Closing time on Saturday:</FormControl.Label>
                <TimeInput
                  value={bizSaturdayClose}
                  fullTimeDropdown
                  onChange={(dateString) => setBizSaturdayClose(dateString)}
                />
              </VStack>
            </HStack>
            <HStack
              zIndex={4}
              justifyContent={"center"}
              space={10}
              flexWrap={"wrap"}
            >
              <VStack alignItems={"center"}>
                <FormControl.Label>Opening time on Sunday:</FormControl.Label>
                <TimeInput
                  value={bizSundayOpen}
                  fullTimeDropdown
                  onChange={(dateString) => setBizSundayOpen(dateString)}
                />
              </VStack>
              <VStack alignItems={"center"}>
                <FormControl.Label>Closing time on Sunday:</FormControl.Label>
                <TimeInput
                  value={bizSundayClose}
                  fullTimeDropdown
                  onChange={(dateString) => setBizSundayClose(dateString)}
                />
              </VStack>
            </HStack>
            <HStack
              zIndex={3}
              justifyContent={"center"}
              space={10}
              flexWrap={"wrap"}
            >
              <VStack alignItems={"center"}>
                <FormControl.Label>Breakfast start time:</FormControl.Label>
                <TimeInput
                  value={BreakfastS}
                  fullTimeDropdown
                  onChange={(dateString) => setBreakfastS(dateString)}
                />
              </VStack>
              <VStack alignItems={"center"}>
                <FormControl.Label>Breakfast finish time:</FormControl.Label>
                <TimeInput
                  value={BreakfastF}
                  fullTimeDropdown
                  onChange={(dateString) => setBreakfastF(dateString)}
                />
              </VStack>
            </HStack>
            <HStack
              zIndex={2}
              justifyContent={"center"}
              space={10}
              flexWrap={"wrap"}
            >
              <VStack alignItems={"center"}>
                <FormControl.Label>Lunch start time:</FormControl.Label>
                <TimeInput
                  value={bizLunchOpen}
                  fullTimeDropdown
                  onChange={(dateString) => setBizLunchOpen(dateString)}
                />
              </VStack>
              <VStack alignItems={"center"}>
                <FormControl.Label>Lunch finish time:</FormControl.Label>
                <TimeInput
                  value={bizLunchClose}
                  fullTimeDropdown
                  onChange={(dateString) => setBizLunchClose(dateString)}
                />
              </VStack>
            </HStack>
            <HStack
              zIndex={1}
              justifyContent={"center"}
              space={10}
              flexWrap={"wrap"}
            >
              <VStack alignItems={"center"}>
                <FormControl.Label>Dinner start time:</FormControl.Label>
                <TimeInput
                  value={bizDinnerOpen}
                  fullTimeDropdown
                  onChange={(dateString) => setBizDinnerOpen(dateString)}
                />
              </VStack>
              <VStack alignItems={"center"}>
                <FormControl.Label>Dinner finish time:</FormControl.Label>
                <TimeInput
                  value={bizDinnerClose}
                  fullTimeDropdown
                  onChange={(dateString) => setBizDinnerClose(dateString)}
                />
              </VStack>
            </HStack>
          </View>

          {/* ── Venue Details (Service, Meals, Drinks, Amenities) ──────────── */}
          <View>
            <Text fontSize={"2xl"} fontWeight="bold" mt={5} mb={2}>
              Venue Details
            </Text>
            <Text mb={4} fontSize={"lg"}>
              Please confirm the following details about your venue. Select Yes, No, or leave as Unknown if unsure.
            </Text>

            {/* Service Options */}
            <Text fontSize={"xl"} fontWeight="semibold" mb={2}>Service Options</Text>
            <VStack space={3} mb={4}>
              {[
                { label: "Dine-in", value: bizDineIn, setter: setBizDineIn },
                { label: "Delivery", value: bizDelivery, setter: setBizDelivery },
                { label: "Takeout", value: bizTakeout, setter: setBizTakeout },
                { label: "Curbside pickup", value: bizCurbsidePickup, setter: setBizCurbsidePickup },
              ].map(({ label, value, setter }) => (
                <HStack key={label} alignItems="center" justifyContent="space-between">
                  <Text fontSize="md" flex={1}>{label}</Text>
                  <Radio.Group
                    name={label}
                    value={value === true ? "yes" : value === false ? "no" : "unknown"}
                    onChange={(val) => setter(val === "yes" ? true : val === "no" ? false : null)}
                    accessibilityLabel={`${label} availability`}
                  >
                    <HStack space={4}>
                      <Radio value="yes" accessibilityLabel={`${label} yes`}><Text fontSize="sm">Yes</Text></Radio>
                      <Radio value="no" accessibilityLabel={`${label} no`}><Text fontSize="sm">No</Text></Radio>
                      <Radio value="unknown" accessibilityLabel={`${label} unknown`}><Text fontSize="sm">Unknown</Text></Radio>
                    </HStack>
                  </Radio.Group>
                </HStack>
              ))}
            </VStack>

            {/* Meals Served */}
            <Text fontSize={"xl"} fontWeight="semibold" mb={2}>Meals Served</Text>
            <VStack space={3} mb={4}>
              {[
                { label: "Breakfast", value: bizServesBreakfast, setter: setBizServesBreakfast },
                { label: "Brunch", value: bizServesBrunch, setter: setBizServesBrunch },
                { label: "Lunch", value: bizServesLunch, setter: setBizServesLunch },
                { label: "Dinner", value: bizServesDinner, setter: setBizServesDinner },
                { label: "Dessert", value: bizServesDessert, setter: setBizServesDessert },
                { label: "Vegetarian options", value: bizServesVegetarianFood, setter: setBizServesVegetarianFood },
              ].map(({ label, value, setter }) => (
                <HStack key={label} alignItems="center" justifyContent="space-between">
                  <Text fontSize="md" flex={1}>{label}</Text>
                  <Radio.Group
                    name={label}
                    value={value === true ? "yes" : value === false ? "no" : "unknown"}
                    onChange={(val) => setter(val === "yes" ? true : val === "no" ? false : null)}
                    accessibilityLabel={`${label} availability`}
                  >
                    <HStack space={4}>
                      <Radio value="yes" accessibilityLabel={`${label} yes`}><Text fontSize="sm">Yes</Text></Radio>
                      <Radio value="no" accessibilityLabel={`${label} no`}><Text fontSize="sm">No</Text></Radio>
                      <Radio value="unknown" accessibilityLabel={`${label} unknown`}><Text fontSize="sm">Unknown</Text></Radio>
                    </HStack>
                  </Radio.Group>
                </HStack>
              ))}
            </VStack>

            {/* Drinks */}
            <Text fontSize={"xl"} fontWeight="semibold" mb={2}>Drinks</Text>
            <VStack space={3} mb={4}>
              {[
                { label: "Coffee", value: bizServesCoffee, setter: setBizServesCoffee },
                { label: "Beer", value: bizServesBeer, setter: setBizServesBeer },
                { label: "Wine", value: bizServesWine, setter: setBizServesWine },
                { label: "Cocktails", value: bizServesCocktails, setter: setBizServesCocktails },
              ].map(({ label, value, setter }) => (
                <HStack key={label} alignItems="center" justifyContent="space-between">
                  <Text fontSize="md" flex={1}>{label}</Text>
                  <Radio.Group
                    name={label}
                    value={value === true ? "yes" : value === false ? "no" : "unknown"}
                    onChange={(val) => setter(val === "yes" ? true : val === "no" ? false : null)}
                    accessibilityLabel={`${label} availability`}
                  >
                    <HStack space={4}>
                      <Radio value="yes" accessibilityLabel={`${label} yes`}><Text fontSize="sm">Yes</Text></Radio>
                      <Radio value="no" accessibilityLabel={`${label} no`}><Text fontSize="sm">No</Text></Radio>
                      <Radio value="unknown" accessibilityLabel={`${label} unknown`}><Text fontSize="sm">Unknown</Text></Radio>
                    </HStack>
                  </Radio.Group>
                </HStack>
              ))}
            </VStack>

            {/* Amenities */}
            <Text fontSize={"xl"} fontWeight="semibold" mb={2}>Amenities</Text>
            <VStack space={3} mb={4}>
              {[
                { label: "Outdoor seating", value: bizOutdoorSeating, setter: setBizOutdoorSeating },
                { label: "Live music", value: bizLiveMusic, setter: setBizLiveMusic },
                { label: "Children's menu", value: bizMenuForChildren, setter: setBizMenuForChildren },
                { label: "Good for children", value: bizGoodForChildren, setter: setBizGoodForChildren },
                { label: "Good for groups", value: bizGoodForGroups, setter: setBizGoodForGroups },
                { label: "Good for watching sports", value: bizGoodForWatchingSports, setter: setBizGoodForWatchingSports },
                { label: "Dogs allowed", value: bizAllowsDogs, setter: setBizAllowsDogs },
                { label: "Restroom available", value: bizRestroom, setter: setBizRestroom },
              ].map(({ label, value, setter }) => (
                <HStack key={label} alignItems="center" justifyContent="space-between">
                  <Text fontSize="md" flex={1}>{label}</Text>
                  <Radio.Group
                    name={label}
                    value={value === true ? "yes" : value === false ? "no" : "unknown"}
                    onChange={(val) => setter(val === "yes" ? true : val === "no" ? false : null)}
                    accessibilityLabel={`${label} availability`}
                  >
                    <HStack space={4}>
                      <Radio value="yes" accessibilityLabel={`${label} yes`}><Text fontSize="sm">Yes</Text></Radio>
                      <Radio value="no" accessibilityLabel={`${label} no`}><Text fontSize="sm">No</Text></Radio>
                      <Radio value="unknown" accessibilityLabel={`${label} unknown`}><Text fontSize="sm">Unknown</Text></Radio>
                    </HStack>
                  </Radio.Group>
                </HStack>
              ))}
            </VStack>
          </View>

          <View zIndex={99999}>
            <HStack justifyContent={"space-between"} alignItems={"center"} mt={5} mb={2}>
              <Text fontSize={"2xl"} fontWeight="bold">
                Business Picture
              </Text>
              <Button
                size="sm"
                variant="outline"
                colorScheme="danger"
                onPress={() => history.push(`/editBusiness/${id}/images`)}
              >
                Manage photos
              </Button>
            </HStack>

            <Text mb={2} fontSize={"lg"}>
              Please upload your business picture
            </Text>
            <Text mb={10} fontSize={"md"} color="coolGray.600">
              The more photos we have, the better we can make your venue look on Piatto.
            </Text>
            <VStack zIndex={99999}>
              <MultiImageInput
                images={images}
                max={5}
                setImages={setImages}
                cropConfig={{ crop, ruleOfThirds: true }}
              />
            </VStack>

            <Text fontSize={"2xl"} fontWeight="bold">
              Business Contact
            </Text>

            <Text mb={10} fontSize={"lg"}>
              Please inform us of your business contact details, along with a
              specific phone number and/or email address for ordering if one
              exists. We will not need these details to send orders to you, as
              you will have access to our Venue Dashboard upon submission of
              this form however it may help us to customise our service to you.
            </Text>
            <HStack justifyContent={"center"} space={2} flexWrap={"wrap"}>
              <FormControl w={"49%"}>
                <FormControl.Label>Phone number of business:</FormControl.Label>

                <Input
                  maxLength={12}
                  value={bizPhone}
                  onChangeText={(t) => setBizPhone(t.replace(/[^0-9]/g, ""))}
                  autoComplete="off"
                  placeholder="Phone number of business"
                />
              </FormControl>
              <FormControl w={"49%"}>
                <FormControl.Label>
                  Email address of business:
                </FormControl.Label>

                <Input
                  maxLength={25}
                  value={bizEmail}
                  onChangeText={handleEmailChange}
                  autoComplete="off"
                  placeholder="Email address of business"
                />
                {emailError ? (
                  <Text style={{ color: "red", fontSize: 12 }}>
                    {emailError}
                  </Text>
                ) : null}
              </FormControl>

              <FormControl w={"49%"}>
                <FormControl.Label>Website of business:</FormControl.Label>
                <Input
                  maxLength={25}
                  value={bizWeb}
                  onChangeText={(t) => setBizWeb(t)}
                  autoComplete="off"
                  placeholder="Website of business"
                />
              </FormControl>
              <FormControl w={"49%"}>
                <FormControl.Label>
                  Phone number for ordering at business:
                </FormControl.Label>

                <Input
                  maxLength={12}
                  value={bizOrderPhone}
                  onChangeText={(t) =>
                    setBizOrderPhone(t.replace(/[^0-9]/g, ""))
                  }
                  autoComplete="off"
                  placeholder="Phone number for ordering at business"
                />
              </FormControl>
              <FormControl>
                <FormControl.Label>
                  Email address for sending orders to business:
                </FormControl.Label>

                <Input
                  maxLength={25}
                  value={bizOrderEmail}
                  onChangeText={handleBizOrderEmailChange}
                  autoComplete="off"
                  placeholder="Email address for sending orders to business"
                />
                {bizOrderEmailError ? (
                  <Text style={{ color: "red", fontSize: 12 }}>
                    {bizOrderEmailError}
                  </Text>
                ) : null}
              </FormControl>
              <FormControl zIndex={99999}>
                <FormControl.Label>Businees Cusines</FormControl.Label>

                <Multiselect
                  placeholder="Select Cusines"
                  isObject={false}
                  selectedValues={bizCuisines}
                  onKeyPressFn={function noRefCheck() {}}
                  onRemove={(list, item) => {
                    setBizCusines(list);
                  }}
                  onSearch={function noRefCheck() {}}
                  onSelect={(list, item) => {
                    setBizCusines(list);
                  }}
                  options={Cuisine ? Cuisine.map((c) => c["cuisName"]) : []}
                />
              </FormControl>
              <div id="accessibility">
                <AccessibilityForm
                  onScoreChange={handleScoreChange}
                  formData={form}
                  onFormChange={handleFormChange}
                />
              </div>
            </HStack>
          </View>

          {/* <Center>
            <VStack w={"100%"} space={2}>
              <Button
                onPress={() => {
                  if (wizard === 0) {
                    if (bizName.length > 0 && bizType["typeName"].length > 1) {
                      Setwizard(wizard + 1);
                    } else {
                      Notiflix.Report.Warning(
                        "Warning",
                        `Please fill in all the required fields`,
                        "Close"
                      );
                    }
                  }
                  if (wizard === 1) {
                    if (selected) {
                      Setwizard(wizard + 1);
                      
                    } else {
                      Notiflix.Report.Warning(
                        "Warning",
                        `Please enter your business address`,
                        "Close"
                      );
                    }
                  }
                  if (wizard === 2) {
                    if (
                      bizInsideLowSeatNo.length > 0 &&
                      bizInsideHighSeatNo.length > 0 &&
                      bizOutsideLowSeatNo.length > 0 &&
                      bizOutsideHighSeatNo.length > 0 &&
                      bizInsideLowTableNo.length > 0 &&
                      bizInsideHighTableNo.length > 0 &&
                      bizOutsideLowTableNo.length > 0 &&
                      bizOutsideHighTableNo.length > 0
                    ) {
                      Setwizard(wizard + 1);
                    } else {
                      Notiflix.Report.Warning(
                        "Warning",
                        `please fill all inputs`,
                        "Close"
                      );
                    }
                  }
                  if (wizard === 3) {
                    Setwizard(wizard + 1);
                  }
                }}
              >
                Next
              </Button>
              <Button
                colorScheme="coolGray"
                isDisabled={wizard < 1}
                onPress={() => {
                  Setwizard(wizard - 1);
                }}
              >
                Back
              </Button>
            </VStack>
          </Center> */}


          <VStack>
            {!formReady && (
              <Text mb={2} textAlign="center" accessibilityLiveRegion="polite">
                {venueNotFound
                  ? "We couldn't find this venue, so changes can't be saved."
                  : "Loading venue details… Save is disabled until they load."}
              </Text>
            )}
            <Button
              mb={2}
              isDisabled={!formReady}
              onPress={() => {
                // Never write a form that hasn't been populated from the venue.
                if (!formReady) return;
                if (
                  bizPhone.length > 0 &&
                  bizEmail.length > 0 &&
                  bizWeb.length > 0 &&
                  bizOrderPhone.length > 0 &&
                  bizOrderEmail.length > 0 &&
                  Object.keys(images).length > 0
                ) {
                  const BizInfo = {
                    bizName,
                    bizType,
                    bizInsideLowSeatNo,
                    bizInsideHighSeatNo,
                    bizOutsideLowSeatNo,
                    bizOutsideHighSeatNo,
                    bizInsideLowTableNo,
                    bizInsideHighTableNo,
                    bizOutsideLowTableNo,
                    bizOutsideHighTableNo,
                    bizMondayOpen,
                    bizMondayClose,
                    bizTuesdayOpen,
                    bizTuesdayClose,
                    bizWednesdayOpen,
                    bizWednesdayClose,
                    bizThursdayOpen,
                    bizThursdayClose,
                    bizFridayOpen,
                    bizFridayClose,
                    bizSaturdayOpen,
                    bizSaturdayClose,
                    bizSundayClose,
                    bizSundayOpen,
                    BreakfastS,
                    BreakfastF,
                    bizLunchOpen,
                    bizLunchClose,
                    bizDinnerOpen,
                    bizDinnerClose,
                    bizPhone,
                    bizEmail,
                    bizWeb,
                    bizOrderPhone,
                    bizOrderEmail,
                    // undefined is stripped by editBiz, leaving stored coords intact
                    bizLat: selected?.lat,
                    bizLon: selected?.lng,
                    images,
                    bizCuisines,
                    // No bizId: the field must stay as-is (see editBiz).
                    bizAccessRating,
                    // Service options
                    bizDineIn,
                    bizDelivery,
                    bizTakeout,
                    bizCurbsidePickup,
                    // Meals & drinks
                    bizServesBreakfast,
                    bizServesLunch,
                    bizServesDinner,
                    bizServesBrunch,
                    bizServesBeer,
                    bizServesWine,
                    bizServesCocktails,
                    bizServesCoffee,
                    bizServesVegetarianFood,
                    bizServesDessert,
                    // Amenities
                    bizOutdoorSeating,
                    bizLiveMusic,
                    bizMenuForChildren,
                    bizGoodForChildren,
                    bizGoodForGroups,
                    bizGoodForWatchingSports,
                    bizAllowsDogs,
                    bizRestroom,
                    form,
                    bizDisBath: !!(form?.bizDisBathType && form.bizDisBathType !== 'none'),
                    bizDisBathType: form?.bizDisBathType || null,
                    bizDisBathFeatures: form?.bizDisBathFeatures || [],
                    bizDisEntrance: form?.bizDisEntrance || '',
                    bizDisBathDir: form?.bizDisBathDir || '',
                    bizDisStdBathDir: form?.bizDisStdBathDir || '',
                    ...bizAddress,
                  };
                  dispatch(editBiz(BizInfo, history, id));
                } else {
                  Notiflix.Report.Warning(
                    "Warning",
                    `please fill all Business Contacts information`,
                    "Close"
                  );
                }
              }}
              colorScheme="danger"
            >
              Submit
            </Button>
            <Button
              colorScheme="coolGray"
              mb="10" // Adjust spacing value as needed (max is typically 64)
              onClick={() => history.push(`/Business/${id}`)} // Also fixed the typo in 'Business'
            >
              Back
            </Button>
          </VStack>
        </VStack>
      </Center>
    </VStack>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
  };
};

export default compose(connect(mapStateToProps))(EditBusiness);
